import { all, delay, put, takeLeading } from 'redux-saga/effects'

import { actions } from '..'
import ApiSagas from '../api/sagas'
import addMessage from '../../rest/requests/messages/addMessage'

export default class MessagesSagas {
  static *onAddMessageRequest({
    payload,
  }: ReturnType<typeof actions.messages.addMessageRequest>) {
    const response = yield* ApiSagas.rest(addMessage(payload))

    if (!response.errors) {
      yield delay(500)
      yield put(actions.mail.sendMessageRequest(payload))
      yield put(actions.messages.addMessageSuccess(response.data))
    } else {
      yield put(actions.messages.addMessageError(response.errors))
    }
  }

  static *loop() {
    yield all([
      takeLeading(actions.messages.addMessageRequest, this.onAddMessageRequest),
    ])
  }
}
